// Email Configuration
// You can use one of these methods:

// Option 1: Formspree (Easiest - Recommended)
// 1. Go to https://formspree.io/ and create a free account
// 2. Create a new form
// 3. Copy your form endpoint (looks like: https://formspree.io/f/YOUR_FORM_ID)
// 4. Replace formspreeEndpoint below

// Option 2: EmailJS
// 1. Go to https://www.emailjs.com/ and create a free account
// 2. Add an Email Service (Gmail, Outlook, etc.)
// 3. Create an Email Template
// 4. Get your Public Key from Account > General
// 5. Replace the EmailJS values below

export const emailConfig = {
  // Formspree Configuration (Easiest option)
  useFormspree: true, // Set to true to use Formspree, false for EmailJS or mailto
  formspreeEndpoint: 'YOUR_FORMSPREE_ENDPOINT', // e.g., 'https://formspree.io/f/your_form_id'
  
  // EmailJS Configuration (Alternative)
  serviceID: 'YOUR_SERVICE_ID', // Get this from EmailJS > Email Services
  templateID: 'YOUR_TEMPLATE_ID', // Get this from EmailJS > Email Templates
  publicKey: 'YOUR_PUBLIC_KEY', // Get this from EmailJS > Account > General
  
  // Recipient Email
  toEmail: 'shubhamsabhani06@gmail.com' // Your email address where you want to receive messages
};

// Email Template Variables:
// Make sure your EmailJS template includes these variables:
// - {{to_email}} - recipient email
// - {{from_name}} - sender's name
// - {{from_email}} - sender's email
// - {{subject}} - email subject
// - {{message}} - email message body
// - {{reply_to}} - reply-to address

